var React = require('react');

function ReplaysIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"fill":"#FFF","fillRule":"nonzero","d":"M25 42.46c9.64 0 17.46-7.82 17.46-17.46S34.64 7.54 25 7.54 7.54 15.36 7.54 25 15.36 42.46 25 42.46zM25 45C13.95 45 5 36.05 5 25S13.95 5 25 5s20 8.95 20 20-8.95 20-20 20z","key":0}),React.createElement("path",{"fill":"#38AB50","d":"M20.22 32.16L32.07 25l-11.85-7.16","key":1})]));
}

ReplaysIcon.defaultProps = {"width":"50","height":"50","viewBox":"0 0 50 50"};

module.exports = ReplaysIcon;

ReplaysIcon.default = ReplaysIcon;
